/* eslint-disable jsx-a11y/alt-text */
import React, { useState , useEffect } from 'react'
import './Post.css';
import Avatar from "@material-ui/core/Avatar"
import { db } from './firebase';
import firebase from 'firebase'

function Post({ postId,user, username, caption, imageURL}) {

   const [comments, setComments] = useState([]);
   const [comment, setComment] = useState([]);

   useEffect(() => {
       let unsubscribe;
       if(postId){
           unsubscribe = db
           .collection("posts")
           .doc(postId)
           .collection("comments")
           .orderBy('timestamp', 'desc')
           .onSnapshot((snapshot)=>{
               setComments(snapshot.docs.map((doc) => doc.data()));
           });
       }
       return () => {
           unsubscribe();
       };
   }, [postId]);

   const postComment =(event) =>{
    event.preventDefault();

    db.collection("posts").doc(postId).collection("comments").add({
        text: comment,
        username:user.displayName,
        timestamp: firebase.firestore.FieldValue.serverTimestamp()
    })
    setComment('');
   }

    return (
        <div className = "post">
            <div className ="post__header">
            <Avatar
                className = "post__avatar"
                alt = {username}
                src = "static/images/avatar/1.jpg"
            />

          <h3>{username}</h3>
          </div>
          <img
          className ="post__image" 
          src={imageURL}/> 
          <h4 className = "post__text"> <strong>{username}</strong>: {caption}</h4>

          
          <div className ="post__comments">
          Comments-:<br/>
              {comments.map((comment)=>(
                  <p>
                        
                      <strong>{comment.username}  :- </strong> 
                      {comment.text}
                  </p>
              ))}
          </div>

          {user &&(

            <form className="post__commentBox">
              <input
                  className="post__input"
                  type="text"
                  placeholder="Add a comment here"
                  value ={comment}
                  onChange={(e)=>setComment(e.target.value)}
              />
              <button
                    disabled={!comment}
                    className="post__button"
                    type="submit"
                    onClick={postComment}
              >
              Post
              </button> 
            </form>

          )}
          
        </div>
    )
}

export default Post;
